var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-1 px-4",class:_vm.cssClass,domProps:{"innerHTML":_vm._s(_vm.userAlert.msg)}})}
var staticRenderFns = []

export { render, staticRenderFns }